import { type DateTime } from "luxon";

import { baseRoutes } from "@/api/base-routes";
import type { PlannedProductionData } from "@/schemas";
import { constructUrlFromDateTime, fetchData, type ApiRequestBody } from "@/api/reporting-api";
import type { MachineSelection } from "@/views/reporting/types";

export async function getMachinesInTimeRange(
	schedules: PlannedProductionData[],
	sites: string[],
	startDate: DateTime,
	endDate: DateTime,
	timeZoneId: string,
	signal?: AbortSignal,
): Promise<MachineSelection[]> {
	if (!sites.length || !startDate?.isValid || !endDate?.isValid || startDate.equals(endDate)) {
		return [];
	}

	const endpoint = `${baseRoutes.reporting}/v1/MachineSelection`;
	const url = constructUrlFromDateTime(endpoint, startDate, endDate, timeZoneId);
	const body: ApiRequestBody = { schedules, sites };

	const machines = await fetchData<MachineSelection[]>(url, body, signal);
	return machines ?? [];
}
